/**
 * Created by sumudu on 11/25/16.
 */
(function () {
    angular.module('trainingPrograms')
        .component('assignCrewSearchComponent', {
            templateUrl: 'training-programs/components/training-assign-crew-search-component.tpl.html',
            controller: function (TrainingAssignCrewLogic,TrainingAssignCrewModel,MessageService) {
                var vm = this;

                vm.crewTypes = [];
                vm.crewIds = [];
                vm.trainerTypes = [];
                vm.crewBatchTypes = [];
                vm.isDatesDisabled = false;
                vm.isNoOfDatesDisabled = false;
                vm.searchParam = {
                    selectedTraining : null,
                    trainingDetails : null,
                    crewType: null,
                    crewIds : null,
                    trainerType : null,
                    fromDate : null,
                    toDate : null,
                    crewBatchType: null,
                    orderBy : null,
                };

                vm.$onInit = function () {
                    TrainingAssignCrewLogic.getCrewTypes();
                    TrainingAssignCrewLogic.getTrainerTypes();
                    TrainingAssignCrewLogic.getCrewBatchTypes();
                    TrainingAssignCrewLogic.getCrewIdsByCrewType();

                    TrainingAssignCrewModel.selectedTraining.subscribe(function (training) {
                        vm.searchParam.selectedTraining = training;
                    });

                    TrainingAssignCrewModel.trainingDetails.subscribe(function (trainingDetails) {
                        vm.searchParam.trainingDetails = trainingDetails;
                    });

                    TrainingAssignCrewModel.crewList.subscribe(function (crewList) {
                        vm.crewList = crewList;
                    });

                    TrainingAssignCrewModel.crewTypes.subscribe(function (crewTypes) {
                        vm.crewTypes =  crewTypes;
                    });

                    TrainingAssignCrewModel.trainerTypes.subscribe(function (trainerTypes) {
                        vm.trainerTypes = trainerTypes;
                    })

                    TrainingAssignCrewModel.crewBatchTypes.subscribe(function (crewBatchTypes) {
                      vm.crewBatchTypes = crewBatchTypes;
                    })

                  TrainingAssignCrewModel.crewIds.subscribe(function (crewIds) {
                    vm.crewIds = crewIds;
                  });

                  vm.orderByTypes = [{
                    code: 'crewID',
                    name: 'Crew ID'
                  },{
                    code: 'expiryDate',
                    name: 'Expiry Date'
                  }]

                };

              vm.onChangeCrewType = function() {
                TrainingAssignCrewLogic.getCrewIdsByCrewType(vm.searchParam.crewType.crewTypeCode);
              };

                vm.onSearchClick = function () {
                    if(validateSearchParam()){
                      var isManualSearch = true
                    	TrainingAssignCrewLogic.getCrewList(vm.searchParam, isManualSearch);
                    }
                };

                function validateSearchParam(){
                	//if either from date or to date exist
                	if(!!vm.searchParam.fromDate && (vm.searchParam.toDate == null || vm.searchParam.toDate === '') ){
                		MessageService.error("To Date Is Required.");
                		return false;
                	}else if(!!vm.searchParam.toDate && (vm.searchParam.fromDate == null || vm.searchParam.fromDate === '') ){
                		MessageService.error("From Date Is Required.");
                		return false;
                	}else if(!!vm.searchParam.fromDate && !!vm.searchParam.toDate){
                		var from = moment(vm.searchParam.fromDate, "DD/MM/YYYY");
                		var to = moment(vm.searchParam.toDate, "DD/MM/YYYY");
                		if(!moment(from).isSameOrBefore(to)){
                			MessageService.error("From Date is After To Date.");
                			return false;
                		}
                		return true;
                	}
                	return true;
                }

            },
            bindings: {}
        });
})();
